import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import reducer from "./auth.reducer";
var PERSIST_CONFIG = {
    key: "authV2",
    version: 1,
    storage: storage,
    whitelist: ["hasAccessToken", "selectedDashboardType"],
};
// eslint-disable-next-line import/no-default-export
export default persistReducer(PERSIST_CONFIG, reducer);
